export const getOriginNoTrailingDot = () => {
  if (typeof window === 'undefined') return ''
  const host = window.location.host.replace(/\.$/, '')
  return `${window.location.protocol}//${host}`
}

/**
 * 開啟外部連結，處理各環境的彈窗封鎖：
 * - Telegram Mini App：WebView 會擋 window.open，改用官方 openLink；以 initData 是否有值
 *   判斷是否真的在 Mini App 內（SDK 在一般瀏覽器也會預載，只看 window.Telegram.WebApp 會誤判）
 * - 一般瀏覽器：window.open 被擋（iOS Safari）時回傳 null，退回同分頁導頁，避免存取 null 屬性崩潰。
 *   不可帶 noopener flag（帶了成功也回 null、無法判斷被擋），改手動切斷 opener
 * @param {string} url
 */
export const openExternalUrl = (url) => {
  if (typeof window === 'undefined' || !url) return

  const tgWebApp = window.Telegram?.WebApp
  if (tgWebApp?.initData && typeof tgWebApp.openLink === 'function') {
    tgWebApp.openLink(url)
    return
  }

  const newWindow = window.open(url, '_blank')
  if (newWindow) {
    newWindow.opener = null
  } else {
    window.location.href = url
  }
}
